import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/$operation/$type")({
  component: () => <Outlet />,
});
